<template>
    <div class="footer">
        <div class="footText">
            <span>版权所有：俄罗斯工程院中国中心 &nbsp;&nbsp;&nbsp; 技术运营支持：环球英才网（北京）科技有限公司</span>
            <br>
            <span>京公网安备 11010802026164号 &nbsp;&nbsp; 京ICP备17026440号-1</span>
        </div>
        <!-- <div>Copyright © 2017-<?php echo date('Y');?> 环球英才网 All Rights Reserved</div> -->
    </div>
</template>
<script>
export default {}
</script>
<style scoped>
.footer {
    background: #fff;
    width: 100%;
    text-align: center;
    margin: 130px 0 30px 0;
}

.footText span {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
}
</style>